import { API_BASE_URL } from '../../settings';
import {
  CONTACT_FORM_REQUEST,
  CONTACT_FORM_SUCCESS,
  CONTACT_FORM_FAILURE,
  CONTACT_FORM_RESET
} from './contactUsActionTypes';

// Action creators
export const contactFormRequest = () => ({
  type: CONTACT_FORM_REQUEST
});

export const contactFormSuccess = (response) => ({
  type: CONTACT_FORM_SUCCESS,
  payload: response
});

export const contactFormFailure = (error) => ({
  type: CONTACT_FORM_FAILURE,
  payload: error
});

export const contactFormReset = () => ({
  type: CONTACT_FORM_RESET
});

export const submitContactForm = (contactData) => {
  return (dispatch, getState, {axiosInstance}) => {
    dispatch(contactFormRequest());

    axiosInstance.post(`/notification/contact/submit`, contactData)
      .then(res => {
        dispatch(contactFormSuccess(res.data));
      })
      .catch(error => {
        const errorMessage = error.response?.data?.message || 
                            error.message || 
                            'An unexpected error occurred. Please try again later.';
        dispatch(contactFormFailure(errorMessage));
      });
  };
};

export const resetContactForm = () => {
  return (dispatch) => {
    dispatch(contactFormReset());
  };
};